<template>
  <div class="page-wrap">
    <!-- ========== 新增顶部导航栏 ========== -->
    <div class="page-header">
      <div class="header-left">
        <div class="sidebar-logo">
          <span class="logo-text" @click="goHome">
            <img src="../assets/log/logo.png" alt="" style="width: 110px;cursor:pointer" />
          </span>
        </div>
        <!-- 余额&充值区域 -->
        <div class="balance-box" v-if="visible_loginMenu">
          <span class="balance-text"
            >账户余额：<span class="money">{{ balance }}</span> 元</span
          >
          <el-button type="primary" size="mini" @click="goRecharge">在线充值</el-button>
        </div>
      </div>
      <div class="header-right">
        <!-- 只保留1个铃铛图标，删掉重复铃铛 -->
        <div class="header-icon bell-icon">
          <i class="el-icon-bell"></i>
        </div>
        <!-- 账户下拉菜单 -->
        <div v-if="visible_loginMenu">
          <el-dropdown trigger="click" @command="handleAccountCommand">
            <div class="header-icon user-icon">
              <i class="el-icon-s-custom"></i>
            </div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="info">资产</el-dropdown-item>
              <el-dropdown-item command="logout" divided style="color: #f53f3f">退出</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div v-else>
          <div @click="login">
            <div class="header-icon user-icon">
              <i class="el-icon-user"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      subDrawerVisible: false,
      visible_loginMenu: !!window.sessionStorage.getItem('token'),
      // 当前余额，后续请求后端接口替换即可
      balance: '0.00'
    }
  },
  mounted() {
    if (this.visible_loginMenu) {
      this.getUserBalance()
    }
  },
  methods: {
    // logo跳转首页（SPA无刷新）
    goHome() {
      this.$router.push('/index')
    },
    // 获取用户余额（对接后端接口示例）
    getUserBalance() {
      /*
      axios.get("/api/user/balance").then(res=>{
          this.balance = res.data.balance
      })
      */
    },
    // 跳转充值页面，修改为你的充值路由
    goRecharge() {
      this.$router.push('/zichan')
    },
    openSubMenu2() {},
    handleAccountCommand(command) {
      switch (command) {
        case 'info':
          this.$router.push('/zichan')
          break
        case 'logout':
          this.exit()
          this.$message.success('退出登录')
          break
      }
    },
    login() {
      this.$router.push('/mob')
    },
    exit() {
      this.visible_loginMenu = false
      window.sessionStorage.removeItem('token')
      window.sessionStorage.removeItem('guest_mob')
      window.sessionStorage.removeItem('tokenUserType')
      this.$router.push('/index')
    },
    openSubMenu() {
      this.subDrawerVisible = true
    },
    closeSubDrawer(done) {
      done()
    },
    goPage(path) {
      this.$router.push(path)
      this.subDrawerVisible = false
    }
  }
}
</script>

<style scoped>
.sidebar-logo {
  display: flex;
  align-items: center;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 28px;
}

.balance-box {
  display: flex;
  align-items: center;
  gap: 12px;
}
.balance-text {
  font-size: 14px;
  color: #444;
}
.money {
  font-size: 16px;
  color: #22b8e6;
  font-weight: bold;
}

/* 顶部导航 */
.page-header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 56px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 24px;
  z-index: 99;
  background: #fff;
}
/* 图标整体向左移动80px */
.header-right {
  display: flex;
  align-items: center;
  margin-right: 60px;
  gap: 16px;
}
.header-icon {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  color: #666;
  cursor: pointer;
  border: 1px solid #e8edf2;
  transition: 0.2s;
}
.header-icon:hover {
  color: #22b8e6;
  border-color: #ccebfa;
}

/* 抽屉内子菜单 */
.sub-menu-list {
  padding-top: 12px;
}
.sub-menu-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 16px;
  font-size: 14px;
  color: #333;
  cursor: pointer;
  border-radius: 8px;
  margin-bottom: 4px;
}
.sub-menu-item:hover {
  background: #f0f9fe;
  color: #22b8e6;
}
.sub-menu-item i {
  font-size: 16px;
}

/* 底部悬浮输入框 */
.float-input-panel {
  position: fixed;
  left: 56px;
  right: 0;
  bottom: 0;
  padding: 12px 24px 24px;
  z-index: 100;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.float-input-box {
  width: 100%;
  max-width: 820px;
  background: #ffffff;
  border: 1px solid #e8edf2;
  border-radius: 16px;
  padding: 12px 16px;
  display: flex;
  align-items: flex-start;
  gap: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
}

.float-input-left {
  width: 36px;
  height: 36px;
  background: #f5f7fa;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-top: 4px;
}

.float-add-icon {
  color: #999;
  font-size: 16px;
}

.float-textarea {
  flex: 1;
  border: none;
  outline: none;
  resize: none;
  height: 42px;
  font-size: 14px;
  color: #333;
  line-height: 1.5;
}

.float-textarea::placeholder {
  color: #999;
}

.float-input-right {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 4px;
}

.float-btn {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  background: #f8fafc;
  border: 1px solid #dde5ee;
  color: #666;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
}

.float-send-btn {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  background: #22b8e6;
  border: none;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
}

.float-send-btn:hover {
  background: #1ea3cc;
}

/* 快捷标签 */
.float-quick-tags {
  width: 100%;
  max-width: 820px;
  display: flex;
  justify-content: center;
  gap: 12px;
  margin-top: 12px;
}

.quick-tag {
  font-size: 13px;
  color: #666;
  background: #f5f7fa;
  border: 1px solid #e8edf2;
  border-radius: 20px;
  padding: 6px 14px;
  cursor: pointer;
  transition: all 0.2s;
}

.quick-tag:hover {
  color: #22b8e6;
  border-color: #ccebfa;
  background: #f0f9fe;
}

.page-wrap {
  background-color: #fbfcfd;
  min-height: 100vh;
  padding-top: 56px;
}
.main-content {
  padding: 30px 60px;
  width: 60%;
  margin: 0 auto;
}
.page-top-title {
  text-align: center;
  margin-bottom: 26px;
}
.page-top-title h1 {
  font-size: 24px;
  font-weight: normal;
  color: #333;
  margin: 0;
}
.blue-word {
  color: #22b8e6;
}

/* 输入框整体 */
.input-wrap {
  display: flex;
  justify-content: center;
  margin-bottom: 30px;
}
.input-box {
  width: 820px;
  background: #fff;
  border: 1px solid #e8edf2;
  border-radius: 16px;
  padding: 16px;
}
.input-left-add {
  width: 36px;
  height: 36px;
  background: #f5f7fa;
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #999;
  vertical-align: top;
  margin-right: 10px;
}
.main-input {
  width: calc(100% - 50px);
  border: none;
  outline: none;
  resize: none;
  height: 70px;
  font-size: 14px;
  color: #333;
}
.input-bottom-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 12px;
}
.left-btns {
  display: flex;
  gap: 8px;
}
.right-btns {
  display: flex;
  gap: 12px;
  align-items: center;
  color: #777;
}

/* 功能按钮横向布局 */
.func-row {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
  margin-bottom: 32px;
}

/* 标签+搜索 */
.tab-search-bar {
  display: flex;
  align-items: center;
  gap: 20px;
  margin-bottom: 20px;
}
.tab-list {
  display: flex;
  gap: 24px;
}
.tab {
  font-size: 15px;
  color: #777;
  cursor: pointer;
  padding: 4px 0;
}
.tab.active {
  color: #22b8e6;
  border-bottom: 2px solid #22b8e6;
}

/* 作品瀑布流 */
.waterfall-list {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 14px;
}
.waterfall-item {
  border-radius: 10px;
  overflow: hidden;
  background: #fff;
}
.waterfall-item img {
  width: 100%;
  display: block;
}
.item-info {
  padding: 8px;
  font-size: 13px;
  color: #333;
}

/* 右侧悬浮AI按钮 */
.float-ai-btn {
  position: fixed;
  right: 24px;
  bottom: 100px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #22b8e6;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  cursor: pointer;
}
</style>
